<template>
  <div class="guide-page">
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>

      <router-link class="bread-item" :to="{ name: 'accountApplication' }">帮助中心</router-link>

      <div class="bread-arrow" v-if="guideItems[currentRoutePath]">&gt;</div>
      <a class="bread-item" v-if="guideItems[currentRoutePath]">{{guideItems[currentRoutePath]}}</a>
    </div>
    <div class="guide-main">
      <div class="guide-side-bar">
        <el-menu
          :default-active="currentRoutePath"
          :default-openeds="openMenus"
          unique-opened
          router
          @open="menuOpen">
          <el-submenu index="wxaUsage">
            <template slot="title" @click="forHeatMap">新手视频</template>
            <el-menu-item index="wxa-usage">
              <div class="menu-item" @click="forHeatMap">下单流程<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="eNtri-usage">
              <div class="menu-item" @click="forHeatMap">马来西亚eNTRI<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="guide">
            <template slot="title">使用指南</template>
            <el-menu-item index="accountApplication">
                <div class="menu-item" @click="forHeatMap">账号申请<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="bindWeChat">
                <div class="menu-item" @click="forHeatMap">绑定微信<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="accountRecharge">
                <div class="menu-item" @click="forHeatMap">账户充值<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="childrenAccount">
                <div class="menu-item" @click="forHeatMap">子账号开户<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="forwardGoods">
                <div class="menu-item" @click="forHeatMap">转发商品<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="uploadData">
                <div class="menu-item" @click="forHeatMap">上传资料<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="payOrder">
                <div class="menu-item" @click="forHeatMap">支付订单<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="interviewProduct">
                <div class="menu-item" @click="forHeatMap">欧美国家办理<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="eNTRI">
                <div class="menu-item" @click="forHeatMap">马来西亚eNTRI<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="offlineOrder">
                <div class="menu-item" @click="forHeatMap">线下订单<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <!-- <el-menu-item index="OtaOrder">
                <div class="menu-item" @click="forHeatMap">OTA订单<i class="el-icon-arrow-right"></i></div>
            </el-menu-item> -->
            <el-menu-item index="mailMaterial">
                <div class="menu-item" @click="forHeatMap">寄送资料<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
            <el-menu-item index="aboutOrder">
                <div class="menu-item" @click="forHeatMap">订单处理<i class="el-icon-arrow-right"></i></div>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="guide-content">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

export default {
  name: 'guide',
  data() {
    return {
      guideItems: {
        accountApplication: '账号申请',
        bindWeChat: '绑定微信',
        accountRecharge: '账户充值',
        forwardGoods: '转发商品',
        uploadData: '上传资料',
        payOrder: '支付订单',
        interviewProduct: '欧美国家办理',
        offlineOrder: '线下订单',
        mailMaterial: '寄送资料',
        aboutOrder: '订单处理',
        childrenAccount: '子账号开户',
        OtaOrder: 'OTA订单',
      },
    };
  },
  methods: {
    menuOpen(index) {
      this.$router.push({ name: index });
    },
    forHeatMap(e) {
      sensorsdata.quick('trackHeatMap', e.target);
    },
  },
  computed: {
    currentRoutePath() {
      if (this.$route.name === 'wxaUsage') {
        return 'wxa-usage';
      }
      if (this.$route.name === 'eNtriUsage') {
        return 'wxa-usage';
      }
      return this.$route.name;
    },
    openMenus() {
      if (this.$route.name === 'wxaUsage' || this.$route.name === 'eNtriUsage') {
        return ['wxaUsage'];
      }
      return ['guide'];
    },
  },
  created() {},
};
</script>

<style lang="less">
@import "../../assets/less/variable";

.guide-page {
  width: 1000px;
  margin: 0 auto 60px auto;
  .el-submenu .el-menu-item {
    min-width: 180px;
  }
  .bread {
    line-height: 20px;
  }
  .guide-main {
    .el-submenu__title {
      background-color: white;
      color: #333;
      padding-left: 30px !important;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      .el-submenu__icon-arrow {
        right: 30px;
        color: #aaa;

        &::before {
          content: "\E604";
        }
      }
    }
    .el-submenu {
      & + .el-submenu {
        border-top: 1px solid @border;
      }

      &.is-opened {
        .el-submenu__title {
          background-color: @main;
          color: white;

          .el-submenu__icon-arrow {
            color: white;
          }
        }
      }

      .el-menu {
        background-color: #fbfbfb;
        .el-menu-item {
          position: relative;
          height: 44px;
          line-height: 44px;
          &:hover {
            background-color: rgba(94, 155, 225, .2);
          }
          .menu-item {
            border-bottom: 1px solid #f0f0f0;
            font-size: 14px;
            i {
              position: absolute;
              right: 15px;
              top: 15px;
              color: #cfcfcf;
            }
          }
          &.is-active {
            font-weight: 600;

            i {
              color: @blue;
            }
          }
        }
      }
    }
    background-color: #fff;
    border: 1px solid #ededed;
    .guide-side-bar {
      padding-top: 32px;
      width: 180px;
      float: left;

      & > .el-menu {
        border-top: 1px solid @border;
        border-bottom: 1px solid @border;
      }
    }
    .guide-content {
      min-height: 600px;
      margin-left: 180px;
      border-left: 1px solid #ededed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/Guide.vue